export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/elearning_content_development.ea99a89.svg";